<div class="backBackground">
    <div class="transitionEffectAll600 roundedCorner"
        [ngClass]="{'mainZero' : auth.currentUserIDSig()?.uid == null, 'mainMax' : sb.currentSidebarSize() === 'max' && auth.currentUserIDSig()?.uid != null,'mainMin' : sb.currentSidebarSize() === 'min' && auth.currentUserIDSig()?.uid != null}"
        *transloco="let t">
        <div class="page-content container-fluid base-font-color">
            <div class="row">
                <div class="col p-0 p-md-1">
                    @if (auth.currentUserIDSig()?.uid != null) {

                    @if(showSpinner || !this.auth.currentLangSig()?.lang) {
                    <div class="row">
                        <div class="col">
                            <span class="placeholder-glow">
                                <span class="placeholder placeholder-lg col-4"></span>
                            </span>
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col text-center">
                            <div class="svl-ripple">
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    </div>
                    }
                    @if(!showSpinner && this.auth.currentLangSig()?.lang) {
                    <div class="page-header base-font-color">
                        <h2 title="{{t('input.header-title')}}">{{t('input.header-title')}}</h2>
                    </div>
                    <div class="row">
                        <div class="inputOptions">
                            <div class="d-flex">
                                <span><small>{{t('input.compact')}}</small></span>
                                <div class="form-check form-switch ms-2 me-1">
                                    <input class="form-check-input" type="checkbox" role="switch"
                                        id="formComplexitySwitch" (change)="toggleFormComplexity()"
                                        [checked]="complexInputForm">
                                    <label class="form-check-label" for="formComplexitySwitch"></label>
                                </div>
                                <span><small>{{t('input.complex')}}</small></span>
                                <span class="material-symbols-outlined ms-2" data-bs-toggle="modal"
                                    data-bs-target="#compactComplexModal">
                                    info
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xxl-2 col-xl-2 order-xl-1">
                        </div>
                        <div class="col-xxl-8 col-xl-8 order-xl-2">
                            <div class="card inputSize mx-auto">
                                <div class="card-body">
                                    <form #TransactionForm="ngForm" autocomplete="off" class="super-font"
                                        (ngSubmit)="onSubmit(transactionModel, transactionModel.Category['id'], TransactionForm);">
                                        <div class="row inputForRow g-2 align-items-center">
                                            <div class="col-auto inputFormIconBox m-0">
                                                <span
                                                    class="material-symbols-outlined input-icon-grey mt-1 mt-1">attach_money</span>
                                            </div>
                                            <div class="col m-0 ps-0">
                                                <div class="form-floating">
                                                    <input type="text" class="form-control form-font bord" required
                                                        id="inputAmount" pattern="^[0-9]+(\.[0-9]{1,2})?$"
                                                        [class.is-invalid]="Amount.invalid && Amount.touched"
                                                        [(ngModel)]="transactionModel.Amount" #Amount="ngModel"
                                                        name="Amount" placeholder="0.00" />
                                                    <label class="grey-label mb-0"
                                                        for="inputAmount">{{t('input.form-amount-plain') }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row inputForRow g-2 align-items-center">
                                            <div class="col-auto inputFormIconBox m-0">
                                                <span
                                                    class="material-symbols-outlined input-icon-grey mt-1">event</span>
                                            </div>
                                            <div class="col m-0 ps-0">
                                                <div class="form-floating">
                                                    <input type="date" class="form-control" id="inputDate"
                                                        [(ngModel)]="transactionModel.Date" #Date="ngModel" name="Date"
                                                        [class.is-invalid]="transactionModel.Date < this.db.currentUserDataSig()?.regDate! || transactionModel.Date> this.defaultDate.toISOString().substring(0, 10)">
                                                    <label class="form-check-label" for="inputDate">
                                                        {{t('input.form-date') }}
                                                    </label>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="row inputForRow align-items-center">
                                            <div class="btn-group btn-group-sm" role="group">
                                                <button type="button" class="btn btn-outline-primary"
                                                    (click)="this.setDate('today')"><small>{{t('input.today')}}</small></button>
                                                <button type="button" class="btn btn-outline-primary"
                                                    (click)="this.setDate('yesterday')"><small>{{t('input.yesterday')}}</small></button>
                                                <button type="button" class="btn btn-outline-primary"
                                                    (click)="this.setDate('lastWeek')"><small>{{t('input.last-week')}}</small></button>
                                                <button type="button" class="btn btn-outline-primary"
                                                    (click)="this.setDate('lastMonth')"><small>{{t('input.last-month')}}</small></button>
                                            </div>
                                        </div>

                                        <div class="row inputForRow g-3 align-items-center">
                                            <div class="col-auto inputFormIconBox m-0">
                                                <span
                                                    class="material-symbols-outlined input-icon-grey mt-1">view_column</span>
                                            </div>
                                            <div class="col m-0 ps-0">
                                                <div class="form-floating">
                                                    <select class="form-select" name="Category" #Category="ngModel"
                                                        [(ngModel)]="transactionModel.Category" type="text"
                                                        id="inputCategory" value="Select Category"
                                                        (change)="listOfSubCats(transactionModel.Category['id']);"
                                                        [class.is-invalid]="transactionModel.Category =='Select Category' && Category.touched">
                                                        <option value="Select Category" disabled>
                                                            {{t('input.form-category-default')}}</option>
                                                        <option *ngFor="let category of catsArray; index as i;"
                                                            value="{{category.content['name']}}" [ngValue]="category">
                                                            {{category.content['name']}}</option>
                                                    </select>
                                                    <label for="inputCategory">{{t('input.form-category')}}</label>
                                                </div>
                                            </div>
                                            <div class="col m-0 pe-1">
                                                <div class="form-floating">
                                                    <select class="form-select form-font"
                                                        [(ngModel)]="transactionModel.SubCategory" name="SubCategory"
                                                        #SubCategory="ngModel" required id="inputSubCategory"
                                                        [class.is-invalid]="transactionModel.SubCategory == null && SubCategory.touched">
                                                        <option value="null" selected disabled>
                                                            {{t('input.form-subcategory-default')}}</option>
                                                        <option *ngFor="let subCategory of subCatsArray; index as i;"
                                                            value="{{subCategory.content['name']}}"
                                                            [ngValue]="subCategory">
                                                            {{subCategory.content['name']}}</option>
                                                    </select>
                                                    <label
                                                        for="inputSubCategory">{{t('input.form-subcategory')}}</label>
                                                </div>

                                            </div>
                                        </div>

                                        <div class="row inputForRow g-2 align-items-center">
                                            <div class="col-auto inputFormIconBox m-0">
                                                <span
                                                    class="material-symbols-outlined input-icon-grey mt-1">location_on</span>
                                            </div>
                                            <div class="col m-0 ps-0">
                                                <div class="form-floating">
                                                    <input class="form-control form-font my-0" #Where="ngModel"
                                                        [(ngModel)]="transactionModel.Where" name="Where"
                                                        [attr.placeholder]="'input.form-where-placeholder'" type="text"
                                                        id="inputWhere"
                                                        [class.is-invalid]="transactionModel.Where == null && Where.touched">
                                                    <label for="inputWhere">{{t('input.form-where')}}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row inputForRow g-2 align-items-center"
                                            [class.d-none]="!complexInputForm">
                                            <div class="col-auto inputFormIconBox m-0">
                                                <span
                                                    class="material-symbols-outlined input-icon-grey mt-1">format_quote</span>
                                            </div>
                                            <div class="col m-0 ps-0">
                                                <div class="form-floating">
                                                    <textarea class="form-control form-font my-0" #Description="ngModel"
                                                        rows="2" [(ngModel)]="transactionModel.Description"
                                                        name="Description"
                                                        [attr.placeholder]="'input.form-description-placeholder'"
                                                        type="text"></textarea>
                                                    <label for="floatingSelect">{{t('input.form-description')}}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- payment methods -->
                                        <div class="row inputForRow">
                                            <div class="col ps-2 ms-0 mt-2">
                                                <div class="row g-2 align-items-center mb-3"
                                                    [class.d-none]="!complexInputForm">
                                                    <div class="col-auto inputFormIconBox m-0 invisible">
                                                        <span
                                                            class="material-symbols-outlined input-icon-grey mt-1">location_on</span>
                                                    </div>
                                                    <div class="col m-0 p-0">
                                                        <div class="form-check">
                                                            <input class="form-check-input" type="checkbox"
                                                                id="defaultPaymentMethodCheckbox" value="1" checked
                                                                (change)="togglePaymentMethods()"
                                                                [checked]="isPaymentMethodsDefault">
                                                            <label class="form-check-label"
                                                                for="defaultPaymentMethodCheckbox">
                                                                <small>{{t('input.default-payment-method')}}</small>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- DEFAULT -->
                                                <div class="row g-3 align-items-center"
                                                    [class.d-none]="!complexInputForm || !isPaymentMethodsDefault">
                                                    <div class="col-auto inputFormIconBox m-0">
                                                        <span
                                                            class="material-symbols-outlined input-icon-grey mt-1">wallet</span>
                                                    </div>
                                                    <div class="col m-0 ps-0">
                                                        <div class="form-floating">
                                                            <input type="text" class="form-control form-font bord"
                                                                [(ngModel)]="transactionModel.Method" name="Method"
                                                                #Method="ngModel" id="inputMethodDefault"
                                                                [disabled]="isPaymentMethodsDefault">
                                                            <label
                                                                for="inputMethodDefault">{{t('input.form-method')}}</label>

                                                        </div>
                                                    </div>
                                                    <div class="col m-0 pe-1">
                                                        <div class="form-floating">
                                                            <input type="text" class="form-control form-font bord"
                                                                [(ngModel)]="transactionModel.Account" name="Account"
                                                                #Account="ngModel" required id="inputAccountDefault"
                                                                [disabled]="isPaymentMethodsDefault">

                                                            <label
                                                                for="inputAccountDefault">{{t('input.form-source')}}</label>

                                                        </div>
                                                    </div>



                                                </div>
                                                <!-- CUSTOM -->
                                                <div class="row g-3 align-items-center"
                                                    [class.d-none]="!complexInputForm || isPaymentMethodsDefault">
                                                    <div class="col-auto inputFormIconBox m-0">
                                                        <span
                                                            class="material-symbols-outlined input-icon-grey mt-1">wallet</span>
                                                    </div>
                                                    <div class="col m-0 ps-0">
                                                        <div class="form-floating">
                                                            <select class="form-select form-font"
                                                                [(ngModel)]="transactionModel.Method" name="Method"
                                                                #Method="ngModel" id="inputMethodCustom"
                                                                (change)="paymentMethodSelector(transactionModel.Method);transactionModel.Account = 'default'"
                                                                [class.is-invalid]="transactionModel.Method == 'default' && Method.touched">
                                                                <option
                                                                    *ngFor="let method of this.payments | keyvalue:sortByValueAsc; index as methodIndex;"
                                                                    value="method{{methodIndex+1}}">{{
                                                                    method.value['name']}}
                                                                </option>
                                                            </select>
                                                            <label
                                                                for="inputMethodCustom">{{t('input.form-method')}}</label>
                                                        </div>
                                                    </div>
                                                    <div class="col m-0 pe-1">
                                                        <div class="form-floating">
                                                            <select class="form-select form-font" required
                                                                [(ngModel)]="transactionModel.Account" name="Account"
                                                                #Account="ngModel" required
                                                                [class.is-invalid]="(transactionModel.Account == 'default' || transactionModel.Account == null) && Account.touched">
                                                                <option [ngClass]="{'d-none' : sourceIndex == 0}"
                                                                    *ngFor="let source of this.payments[this.selectedMethod] | keyvalue:sortByValueAsc; index as sourceIndex;">
                                                                    {{source.value['name']}}</option>
                                                            </select>
                                                            <label
                                                                for="floatingSelect">{{t('input.form-source')}}</label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- default payment methods -->

                                        <div class="row text-end">
                                            <div class="col">
                                                @if(!showButtonSpinner) {
                                                <button class="btn btn-secondary rounded-pill" type="submit"
                                                    [disabled]="TransactionForm.form.invalid || Amount.pristine || Where.pristine || transactionModel.Method == 'default' || transactionModel.Method == null || transactionModel.Account == 'default' || transactionModel.Account == null">
                                                    {{t('input.button-add')}}
                                                </button>
                                                }
                                                @if(showButtonSpinner) {

                                                <button class="btn btn-secondary rounded-pill" disabled>
                                                    <span class="spinner-border spinner-border-sm"
                                                        aria-hidden="true"></span>
                                                    <span class="visually-hidden" role="status">Loading</span>
                                                    {{t('input.button-add')}}
                                                </button>
                                                }

                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="col-xxl-2 col-xl-2 order-xl-3"></div>
                    </div>
                    }
                    }
                    @if (auth.currentUserIDSig()?.uid == null) {
                    <div class="row">
                        <div class="col">
                            <span class="placeholder-glow">
                                <span class="placeholder placeholder-lg col-4"></span>
                            </span>
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col text-center">
                            <div class="svl-ripple">
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
<!-- MODALS -->


<div class="modal fade" id="compactComplexModal" tabindex="-1" aria-labelledby="compactComplexModalLabel"
    aria-hidden="true" *transloco="let t">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row">
                    <div class="col text-end">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center">
                        <span class="material-symbols-outlined modal-icon-grey align-content-center">
                            info
                        </span>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col text-center">
                        <div class="my-3 text-center">
                            <p><em>{{t('input.compact-full-description')}}</em>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer px-0">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-4 d-grid">
                            <button class="btn btn-sm rounded-pill" type="button" data-bs-dismiss="modal">
                                {{t('general.button-cancel')}}</button>
                        </div>
                        <div class="col-8 d-grid">

                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <a class="btn btn-link btn-link-secondary" data-bs-target="#deleteTransactionModal"
                                data-bs-toggle="modal" title="{{t('transactions.remove-transaction')}}">
                                <div class="d-flex align-items-center">
                                    <span class="">{{ t('general.button-delete') }}</span>
                                </div>
                            </a>
                        </div>
                        <div class="col"><button class="btn btn-outline-secondary rounded-pill w-100"
                                data-bs-dismiss="modal" type="button" title="{{t('general.button-close')}}">
                                {{ t('general.button-close') }}
                            </button></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>